import React from "react";
import "./AgentIntro.css";

const AgentIntro = ({ onContinue }) => {
  return (
    <div className="agent-intro">

      {/* HEADER */}
      <div className="agent-intro-header">
        <div className="agent-intro-badge">
          AGENCY
        </div>

        <h2>Pata Faida Zaidi</h2>

        <p>
          Kuwa wakala ili upate faida zaidi
          kupitia mfumo wetu wa commission.
        </p>
      </div>


      {/* APPLY NOW - IPO JUU */}
      <div className="agent-apply-top">
       
      <button
          type="button"
          className="continue-btn"
          onClick={onContinue}
        >
          Apply Now
        </button>
      </div>

      {/* BENEFITS */}
      <div className="agent-benefits">

        <div className="benefit-card">
          <span className="benefit-number">01</span>
          <div>
            <strong>Bonasi ya Moja kwa Moja</strong>
            <p>
              Utapata sehemu ya marejesho baada ya kuwa mshirika.
            </p>
          </div>
        </div>

        <div className="benefit-card">
          <span className="benefit-number">02</span>
          <div>
            <strong>Bonasi ya Timu</strong>
            <p>
              Kadri unavyounda timu kubwa, ndivyo faida yako itaongezeka.
            </p>
          </div>
        </div>

        <div className="benefit-card">
          <span className="benefit-number">03</span>
          <div>
            <strong>Bonasi ya Uendelezaji</strong>
            <p>
              Pata bonasi baada ya mualikwa kujisajili na kuweka amana.
            </p>
          </div>
        </div>

        <div className="benefit-card">
          <span className="benefit-number">04</span>
          <div>
            <strong>Tukio Maalum</strong>
            <p>
              Shiriki katika matukio maalum yaliyoandaliwa kwa mawakala.
            </p>
          </div>
        </div>

      </div>


      {/* BONUS SECTION */}
      <div className="bonus-section">

        <div className="bonus-section-header">
          <div>
            <span className="bonus-label">SPECIAL OFFERS</span>
            <h3>BONASI ZA MAWAKALA</h3>
          </div>

          <span className="bonus-star">★</span>
        </div>


        {/* FIRST DEPOSIT BONUS */}
        <div className="bonus-card first-bonus">

          <div className="bonus-card-top">
            <div>
              <span className="bonus-tag">FIRST DEPOSIT</span>

              <h4>First Deposit Bonus</h4>

              <p>
                Weka amana yako ya kwanza na upate bonus
                pamoja na bonus ya referrer.
              </p>
            </div>

            <div className="bonus-percent">
              <strong>10%</strong>
              <span>WEWE</span>
            </div>
          </div>

          <div className="bonus-row">
            <span>10,000 - 999,999 TZS</span>
            <strong>10% + 15%</strong>
          </div>

          <div className="bonus-row">
            <span>1,000,000 - 2,999,999 TZS</span>
            <strong>8% + 15%</strong>
          </div>

          <div className="bonus-row">
            <span>3,000,000 TZS +</span>
            <strong>6% + 15%</strong>
          </div>

        </div>


        {/* SECOND DEPOSIT BONUS */}
        <div className="bonus-card second-bonus">

          <div className="bonus-card-top">
            <div>
              <span className="bonus-tag">SECOND DEPOSIT</span>

              <h4>Second Deposit Bonus</h4>

              <p>
                Fanya amana yako ya pili na upate bonus
                kulingana na kiasi cha amana.
              </p>
            </div>

            <div className="bonus-percent">
              <strong>5%+</strong>
              <span>BONUS</span>
            </div>
          </div>

          <div className="bonus-row">
            <span>300,000 - 499,999 TZS</span>
            <strong>15,000 TZS • 5%</strong>
          </div>

          <div className="bonus-row">
            <span>500,000 - 999,999 TZS</span>
            <strong>30,000 TZS • 6%</strong>
          </div>

          <div className="bonus-row">
            <span>1,000,000 - 2,999,999 TZS</span>
            <strong>70,000 TZS • 7%</strong>
          </div>

          <div className="bonus-row">
            <span>3,000,000 - 4,999,999 TZS</span>
            <strong>120,000 TZS • 8%</strong>
          </div>

          <div className="bonus-row">
            <span>5,000,000 TZS +</span>
            <strong>500,000 TZS FIXED</strong>
          </div>

        </div>


        {/* WEEKLY BONUS */}
        <div className="bonus-card weekly-bonus">

          <div className="bonus-card-top">
            <div>
              <span className="bonus-tag">WEDNESDAY</span>

              <h4>Weekly Bonus</h4>

              <p>
                Weka amana siku ya Jumatano na pata
                bonus ya 5% ya kiasi cha amana yako.
              </p>
            </div>

            <div className="bonus-percent">
              <strong>5%</strong>
              <span>WIKI</span>
            </div>
          </div>

          <div className="weekly-example">
            <span>Mfano</span>
            <strong>Weka 100,000 TZS</strong>
            <b>→</b>
            <strong>Pata 5,000 TZS</strong>
          </div>

          <div className="weekly-rules">

            <div>
              <span>✓</span>
              <small>Weka amana siku ya Jumatano</small>
            </div>

            <div>
              <span>✓</span>
              <small>Amana iwe SUCCESS</small>
            </div>

            <div>
              <span>✓</span>
              <small>Ni amana ya 3 na zaidi</small>
            </div>

            <div>
              <span>✓</span>
              <small>Kiasi cha 50,000 TZS au zaidi</small>
            </div>

          </div>

        </div>


        {/* BONUS NOTE */}
        <div className="bonus-note">
          <strong>🎁 AMANA YAKO, FAIDA YAKO!</strong>

          <span>
            Tumia fursa hizi kuongeza faida zako kama wakala.
          </span>
        </div>

      </div>


      {/* COMMISSION */}
      <div className="commission-section">

        <div className="commission-header">
          <span>COMMISSION</span>
          <strong>Jumla 18%</strong>
        </div>

        <div className="commission-list">

          <div className="commission-item">
            <div>
              <span>LEVEL 1</span>
              <small>Commission ya Level 1</small>
            </div>

            <strong>8%</strong>
          </div>

          <div className="commission-item">
            <div>
              <span>LEVEL 2</span>
              <small>Commission ya Level 2</small>
            </div>

            <strong>6%</strong>
          </div>

          <div className="commission-item">
            <div>
              <span>LEVEL 3</span>
              <small>Commission ya Level 3</small>
            </div>

            <strong>4%</strong>
          </div>

        </div>

      </div>


      {/* FOOTER */}
      <div className="agent-intro-footer">

        <p>
          Jiunge nasi leo na uanze kujenga timu yako.
        </p>


        <button
          type="button"
          className="continue-btn"
          onClick={onContinue}
        >
          Apply Link  Now
        </button>
      

      </div>

    </div>
  );
};

export default AgentIntro;
